<template>
  <div>
    <v-btn :outline="selectedCount === 0" color="primary" @click="showModal" :disabled="disabled">{{buttonText}}</v-btn>

    <v-dialog v-model="modal" :max-width="350">
      <v-card>
          <v-container>
            <h2 class="text-xs-center">{{buttonTitle}}</h2>
            <v-layout row justify-start>
              <v-icon class="mr-1">mdi-blank</v-icon>
              <v-text-field class="mr-4 pt-1" clearable append-icon="search" v-model="searchText" :placeholder="$t('student.filters.list_search_placeholder')"></v-text-field>
            </v-layout>
            <v-layout v-if="showDefaultOption || showDeleteOption" row justify-end>
              <h5 v-if="showDefaultOption">{{$t('my_filter_modal_default')}}</h5>
              <v-icon class="mr-1">mdi-blank</v-icon>
              <h5 v-if="showDeleteOption">{{$t('my_filter_modal_delete')}}</h5>
              <v-icon class="mr-1">mdi-blank</v-icon>
            </v-layout>
            <div v-if="modal" class="filter-list-rows">
              <transition-group name="filter-list">
                <div v-for="row in filteredRows" :key="source.key(row)" :class="tableRowClass">
                    <my-filter-list-row v-if="!row.isHidden"
                                        class="d-flex"
                                        :row="source.mapRow(row)"
                                        :idSet="idSet"
                                        :deleteFilter="deleteFilter"
                                        :selectedButtonText="text"
                                        :show-default-option="showDefaultOption"
                                        :show-delete-option="showDeleteOption"
                                        @selected="selected"></my-filter-list-row>
                </div>
              </transition-group>
            </div>
          </v-container>

          <v-card-actions>
            <v-layout row justify-center class="pt-1 pb-1">
              <v-btn @click="clear" :disabled="selectedCount === 0">{{$t('student.filters.clear')}}</v-btn>
              <v-btn @click="closeModal" color="primary">{{$t('student.filters.okay')}}</v-btn>
            </v-layout>
          </v-card-actions>

      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import MyFilterListRow from './MyFilterListRow'
import Helpers from '../../mixins/Helpers'
import { mapActions } from 'vuex'
import { DELETE_SAVED_FILTER } from '../../store/action-types'

export default {
  name: 'my-filter-list',
  mixins: [Helpers],
  data () {
    return {
      modal: false,
      searchText: '',
      selectedButtonText: ''
    }
  },
  methods: {
    showModal () {
      this.modal = true
    },
    closeModal () {
      this.modal = false
    },
    clear () {
      this.$emit('filter:list-change', {filterName: [], filterType: this.filterType})
    },
    selected (selection) {
      let ids = new Set(this.idSet)
      if (selection.selected) {
        ids.clear()
        ids.add(selection.id)
      } else {
        ids.delete(selection.id)
      }
      this.$emit('filter:list-change', {filterName: Array.from(ids.keys()), filterType: this.filterType})
    },
    deleteFilter (row) {
      let payload = {
        id: row.id,
        toBeDeleted: true
      }
      this.deleteSavedFilter(payload)
      this.modal = false
    },
    text (x) {
      this.selectedButtonText = x
    },
    ...mapActions({
      deleteSavedFilter: DELETE_SAVED_FILTER
    })
  },
  props: {
    source: {
      type: Object,
      required: true
    },
    filterType: {
      type: String,
      required: true
    },
    selectedFilterText: {
      type: Function
    },
    savedFilterText: {
      type: String
    },
    showDefaultOption: {
      type: Boolean,
      required: true
    },
    showDeleteOption: {
      type: Boolean,
      required: true
    },
    disabled: {
      type: Boolean
    }
  },
  computed: {
    idSet () {
      let ids = new Set()
      Object.keys(this.source.idValues).forEach(id => {
        if (this.source.identifier === 'myFilter') {
          ids.add(parseInt(id))
        }
      })
      return ids
    },
    selectedCount () {
      return Object.keys(this.source.idValues).length
    },
    buttonTitle () {
      return this.$t(this.source.title_i18n) + ' Selection'
    },
    buttonText () {
      if (this.selectedCount === 0) {
        this.selectedFilterText({title: '', id: undefined})
        return this.$t(this.source.button_unselected_i18n)
      } else {
        let id = parseInt(Object.keys(this.source.idValues)[0])

        let defaultSearch
        let selectedText
        Object.keys(this.source.items).forEach(filter => {
          if (this.source.items[filter].id === id) {
            defaultSearch = this.source.items[filter].defaultSearch
            selectedText = this.source.items[filter].description
          }
        })
        this.selectedFilterText({title: selectedText, id: id, defaultSearch: defaultSearch})
        return (selectedText) && selectedText.length > 12 ? selectedText.substring(0, 12) + '...' : selectedText
      }
    },
    filteredRows () {
      let text = (this.searchText === null) ? '' : this.searchText
      return this.source.items.filter(item => this.source.containsText(item, text))
    }
  },
  components: {
    MyFilterListRow
  }
}
</script>

<style scoped>
.filter-list-rows {
  overflow: auto;
  height: 55vh;
  max-height: calc(100vh - 340px);
  -webkit-overflow-scrolling: touch;
}
  /* Transitions */
.filter-list-enter-active,
.filter-list-leave-active {
  transition: all 0.4s;
  opaque: 1;
}

.filter-list-enter, .filter-list-leave-to /* .fade-leave-active below version 2.1.8 */
{
  opacity: 0;
  transform: translate(-16px, 0px)
}
</style>



// WEBPACK FOOTER //
// src/components/filter/MyFilterList.vue